import React, { Component, Fragment } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Select from 'react-select';
import format from 'date-fns/format';

import Tippy from '../../../utils/Tippy';
import Icon, {
  UserIcon,
  ClipboardIcon,
  ChatIcon,
  QuoteIcon,
  ArchiveIcon,
  ThrashIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
} from '../../../utils/icons';

const ARCHIVED_CHAT_LIST_QUERY = gql`
  {
    archivedChats {
      id
      messages {
        id
        text
        sender
        source
        sent
      }
      created
    }
  }
`;

const ArchivedChatList = props => (
  <Query query={ARCHIVED_CHAT_LIST_QUERY} fetchPolicy="cache-and-network">
    {({ loading, error, data }) => {
      if (error) return null;
      if (loading)
        return (
          <div className="chat-list">
            <div className="chat-list-header">Ladataan...</div>
            <div className="chat-list-items" />
          </div>
        );

      const { chatId: selectedChatId } = props.match.params;
      const chats = data ? data.archivedChats : null;

      return (
        <div className="chat-list">
          <div className="chat-list-header">Logit</div>
          <div className="chat-list-items">
            {chats &&
              chats.map((chat, i) => {
                const classes = classNames({
                  'chat-list-item': true,
                  'chat-list-item-active': chat.id == selectedChatId,
                });

                return (
                  <Link
                    key={`${chat.id}-${i}`}
                    to={`/chats/archived/${chat.id}`}
                  >
                    <div className={classes}>
                      <div className="chat-list-item-id">{chat.id}</div>
                      <div className="chat-list-item-messages">
                        <Icon
                          icon={ChatIcon}
                          className="chat-list-item-messages-icon"
                        />{' '}
                        {chat.messages.length}
                      </div>
                      <div className="chat-list-item-created">
                        {format(chat.created, 'DD.MM.YYYY, HH:mm')}
                      </div>
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      );
    }}
  </Query>
);

export default withRouter(ArchivedChatList);
